import React from 'react'
import { Link } from 'react-router-dom'
import { getMessage } from 'lib/translator'
import AuthenticatedPage from 'containers/AuthenticatedPage';
import API from 'lib/api'
import { Dialog } from 'components/Popup'
import {
  BaseForm,
} from 'components/Form'
import { ReactComponent as CloseIcon } from 'icons/close-icon-black.svg'
import Loader from 'components/Loader'
import ConfigDisplay from './ConfigDisplay'
import CampaignConfigInputs from './CampaignConfigInputs';
import CampaignsRanking from './CampaignsRanking';
import CampaignsOrderLogPopup from './CampaignsOrderLogPopup';
import './style.scss'

class CampaignConfiguration extends BaseForm {
	constructor(props) {
		super(props)
		this.state = {
      isConfigEditMode: false,
      submitting: false,
      showCampaignsOrderLogPopup: false,
      errorDialogMsg: null
		}

    this.toggleConfigEditMode = this.toggleConfigEditMode.bind(this);
    this.moveCampaign = this.moveCampaign.bind(this);
    this.toggleLogPopup = this.toggleLogPopup.bind(this);
	}

  componentDidMount() {
    const api = new API({
      url: `/offer-service/campaigns/voucher-center-info`,
    })
    api.get()
      .then((res) => {
        this.setState({
          values: res.data
        })
      })
      .catch(err => {
        if (err.code === 400 || err.code === 500) {
          this.setState({ errorDialogMsg: err?.message || getMessage('offer.campaigns.form.error') })
        }
      })
    //campaigns/voucher-center-info 
  }

  onSubmit(formData) {
    // custom validations upon submit
    if (formData.title.length > 14) {
      this.setState({
        errorDialogMsg: `title: ${formData.description.length} characters (character limit is 14.)`
      })
    } else if (formData.description.length > 28) {
      this.setState({
        errorDialogMsg: `description: ${formData.description.length} characters (character limit is 28.)`
      })
    } else {
      this.setState({
        submitting: true,
      })
      const data = Object.assign(
        {},
        {
          ...formData,
        }
      )
  
      const api = new API({
        url: `/offer-service/campaigns/voucher-center-info`,
      })
      api
        .post(data)
        .then((res) => {
          if (res) {
            this.props.history.push(`/marketing/voucher-center-campaigns`)
          }
        })
        .catch((err) => {
          if (err.code === 400 || err.code === 500) {
            this.setState({ errorDialogMsg: err?.message || getMessage('offer.campaigns.form.error') })
          }
        })
        .finally(() => this.setState({ submitting: false }))
    }

  }

  toggleConfigEditMode() {
    this.setState({ isConfigEditMode: !this.state.isConfigEditMode })
  }

  toggleLogPopup(e) {
    e && e.preventDefault()
    this.setState({ showCampaignsOrderLogPopup: !this.state.showCampaignsOrderLogPopup})
  }

  moveCampaign() {
    return {
      top: (index) => {
        if (index > 0) {
          // Only move if not already at the top
          this.setState((prevState) => {
            const newCampaignsOrder = [...prevState.values.campaignsOrder]
            const movedRule = newCampaignsOrder.splice(index, 1)[0]
            newCampaignsOrder.unshift(movedRule) // Add it to the beginning
            return {
              values: {
                ...prevState.values,
                campaignsOrder: newCampaignsOrder,
              },
            }
          })
        }
      },
      up: (index) => {
        if (index > 0) {
          this.setState((prevState) => {
            const newCampaignsOrder = [...prevState.values.campaignsOrder];
            [newCampaignsOrder[index - 1], newCampaignsOrder[index]] = [
              newCampaignsOrder[index],
              newCampaignsOrder[index - 1],
            ]
            return {
              values: {
                ...prevState.values,
                campaignsOrder: newCampaignsOrder,
              },
            }
          })
        }
      },
      down: (index) => {
        if (index < this.state.values.campaignsOrder.length - 1) {
          this.setState((prevState) => {
            const newCampaignsOrder = [...prevState.values.campaignsOrder];
            [newCampaignsOrder[index + 1], newCampaignsOrder[index]] = [
              newCampaignsOrder[index],
              newCampaignsOrder[index + 1],
            ]
            return {
              values: {
                ...prevState.values,
                campaignsOrder: newCampaignsOrder,
              },
            }
          })
        }
      },
      bottom: (index) => {
        if (index < this.state.values.campaignsOrder.length - 1) {
          // Only move if not already at the bottom
          this.setState((prevState) => {
            const newCampaignsOrder = [...prevState.values.campaignsOrder]
            const movedCampaign = newCampaignsOrder.splice(index, 1)[0]
            newCampaignsOrder.push(movedCampaign) // Add it to the end
            return {
              values: {
                ...prevState.values,
                campaignsOrder: newCampaignsOrder,
              },
            }
          })
        }
      },
    }
  }

	render() {
		const { menu } = this.props;
    const { Form } = this.components
    const { SubmitButton } = this.buttons

    if (!this.state.values) {
      return <Loader />
    }

		return (
			<AuthenticatedPage
			className="voucher-center-campaigns-configuration"
			menu={menu}>
			  <h1 className="title">Campaigns Configuration</h1>
		
			  <div className='campaigns-config-container'>
          <Form className="campaigns-config-form">
            {
              this.state.isConfigEditMode ?
                <div className='config-display'>
                  <div className="config-title">
                      <h2>Edit Voucher Center Config</h2>
                      <button
                        className='edit-config-close-btn'
                        data-testid='edit-config-close-btn'
                        onClick={(e) => {
                            e.preventDefault()
                            this.toggleConfigEditMode()
                        }}>
                        <CloseIcon height={14} width={14} />
                      </button>
                  </div>
                  <br/>
                  <CampaignConfigInputs 
                    values={this.state.values}
                    generateStateMappers={this.generateStateMappers} />
                </div> 
              :
              <ConfigDisplay 
                data={this.state.values} 
                toggleConfigEditMode={this.toggleConfigEditMode}
                title="Voucher Center Details" />
            }
            {
              this.state.values.campaignsOrder.length > 0 &&
              <CampaignsRanking 
                toggleLogPopup={this.toggleLogPopup}
                moveCampaign={this.moveCampaign()}
                campaignsOrder={this.state.values.campaignsOrder} />
            }
            <div className="form-buttons">
              <SubmitButton>{getMessage('offer.submit')}</SubmitButton>
              <Link to="/marketing/scan-campaigns">
                <button className="secondary button">
                  {getMessage('offer.cancel')}
                </button>
              </Link>
            </div>
            </Form>
			  </div>

        {this.state.errorDialogMsg && (
          <Dialog
            className="error-dialog"
            show={!!this.state.errorDialogMsg}
            title="Error"
            information={this.state.errorDialogMsg}
            close={() => this.setState({ errorDialogMsg: null })}
            closeText={getMessage('dialog.okText')}
          />
        )}

        <CampaignsOrderLogPopup 
          toggleLogPopup={this.toggleLogPopup}
          showCampaignsOrderLogPopup={this.state.showCampaignsOrderLogPopup} />
			</AuthenticatedPage>
		)
	}
}

export default CampaignConfiguration
